// AdminPanel.js
import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import BarraNavegacion from '../componentes/BarraNavegacion';
import UserManagement from '../componentes/UserManagement';
import ContentManagement from '../componentes/ContentManagement';
import { useAuth } from '../servicios/store';
import './AdminPanel.css';

const AdminPanel = () => {
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState('usuarios');

  return (
    <div className="admin-container">
      <BarraNavegacion />
      
      <Tabs activeKey={activeTab} onSelect={setActiveTab}>
        <Tab eventKey="usuarios" title="Gestión de Usuarios">
          <UserManagement currentUser={currentUser} />
        </Tab>

        <Tab eventKey="contenidos" title="Gestión de Contenidos">
          <ContentManagement currentUser={currentUser} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default AdminPanel;